// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.deactivate.RentalManagerUserPropertyDeactivateWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { DeactivateListingRequestDto, DeactivateListingResponseDto, ListingAlias } from '../..';

interface LeasesParams {
  listingAlias: ListingAlias;
  type: string;
  value: boolean;
}

export const RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Path =
  '/api/web/v1/users/properties/deactivate/deactivateListing';

export const RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing = (
  postData: DeactivateListingRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, DeactivateListingRequestDto, DeactivateListingResponseDto>({
    endpoint: RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertyDeactivateWebApiHandler_leases_Path =
  '/api/web/v1/users/properties/deactivate/leases';

/**
 * Save leases survey response. Types: haveSignedLease, uploadSignedLease, haveLeaseAgreement, uploadUnsignedLease, createLease
 */
export const RentalManagerUserPropertyDeactivateWebApiHandler_leases = (
  getParams: LeasesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<LeasesParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyDeactivateWebApiHandler_leases_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};
